export default "__VITE_ASSET__l5G5of2S__"